import ReactDOM from 'react-dom';
import StartWidget, { StartWidgetProps } from './StartWidget';
import React from 'react';

window['kizi_render_comparator_widget'] = (
  props: StartWidgetProps = {},
  domTarget = 'kizi-comparator-os-health-start-widget'
) => {
  const mountNode = document.getElementsByClassName(domTarget)[0];
  ReactDOM.render(<StartWidget {...props} />, mountNode);
};

const event = new CustomEvent('kizi-comparator-widget-ready');

window.dispatchEvent(event);
